import React from "react";

export default function Mensaje190698() {
  return (
    <>
      <p>
        <h6>
          19 de junio de 1998 <i>(Día del Sagrado Corazón de Jesús)</i>
        </h6>
        <br />
        <p>
          Amados hijitos: <br />
          Sed fieles a la oración. <br />
          Cada vez que oréis, poneos ante el Divino Corazón de Mi Hijo presente
          en el tabernáculo. <br />
          Pedid allí por todas vuestras necesidades. <br />
          La oración ante Jesús Sacramentado es poderosa. Decid: <br />
          <i>
            - Sagrado y Divino Corazón de Jesús, humildemente creo que estás
            aquí presente. <br />
            - Creo con mi pobre corazón. <br />
            - Te adoro Hostia Divina y confío en Tú infinita Misericordia, que
            sostiene a toda humanidad. <br />
            - Sé que no soy digno de Ti, ayúdame a vencer las dificultades de
            ésta vida. <br />
            - Cambia mi corazón. <br />
            - Concédeme Gracia a través del Inmaculado Corazón de Tu Santa
            Madre. <br />
            - Bendito, adorado y alabado seas Corazón de Jesús. <br />
            Amén. <br />
          </i>
          Os bendigo especialmente. <br />
          Amén. Aleluya. Amén. Aleluya. <br />
        </p>
      </p>
    </>
  );
}
